import React from "react";
import { Link } from "react-router-dom";
import { createSEOUrl } from "../../../../utils/createSEOUrl";
import "./mostRecent.css";

export default function MostRecent({ posts }) {

  return (
    <div className="most-recent-outer">
      <div className="most-recent-container">
        <h3>Senaste inläggen</h3>
        <ul>
          {posts.length > 0 ? (
            posts.map((post) => (
            <li key={post._id}>
              <Link
                className="most-recent-item"
                to={`/blogg/${createSEOUrl(post.slug)}`}
              >
                <p className="most-recent-title">{post.title}</p>
              </Link>
            </li>
            ))
            ) : (
              <p>Inga blogginlägg att visa just nu.</p>
            )}
        </ul>
      </div>
    </div>
  );
}
